import styled from "styled-components";
import { device } from "../../device";

export const StyledHome = styled.section``;

export const Heading = styled.h1`
  font-size: 1rem;
  color: #8b8b8b;
  text-align: left;
  padding: 0;
  margin: 0;
`;

export const Image = styled.img`
  max-width: 100%;
  height: auto;
`;
export const LocationDetailItem = styled.div`
  border-top: 1px solid #8b8b8b;
`;

export const Key = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 20px;
  margin-left: auto;
  @media ${device.tablet} {
    padding-top: 20px;
    width: 100%;
    top: 0;
  }
`;
export const KeyItem = styled.div`
  font-size: 0.8rem;
  color: #636363;

  &:first-child {
    padding-right: 20px;
  }
`;
export const LocationDetailItems = styled.div`
  @media ${device.tablet} {
    position: relative;
    height: 100%;
    max-height: 617px;
    overflow-y: scroll;
  }
`;
